import {
  Badge,
  Button,
  ComboboxItem,
  Grid,
  Input,
  Text,
  Title,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconSearch, IconUsers } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { cobalt_blue, green } from "../../../../const/variables";
import {
  getProvinceSelect,
  getTblDmCustomerGroupSelect,
} from "../../../../service/getSelectApi";
import CreateDataView from "../../../CustomerManagement/CustomerList/CreateDataView";
import { CellDoubleClickedEvent } from "ag-grid-community";

interface Customer {
  active: boolean;
  address: string;
  attribute1: string | null;
  attribute2: string | null;
  attribute3: string | null;
  attribute4: string | null;
  attribute5: string | null;
  birthOfDate: string; // ISO 8601 Date format
  buyerName: string;
  code: string;
  commune: number;
  communeName: string;
  companyName: string;
  contact: string | null;
  country: string | null;
  debtLimit: number;
  debtTerm: number;
  description: string | null;
  district: number;
  districtName: string;
  email: string;
  fax: string | null;
  groupCode: string;
  groupId: number;
  groupName: string;
  id: number;
  name: string;
  province: number;
  provinceName: string;
  sex: number; // 1: Male, 2: Female, 3: Other
  taxCode: string;
  tblDmCustomerGroupModel: string | null;
  telephoneNumber: string;
  type: number; // Typically 1: Individual, 2: Corporate
}

const ListCustomer = ({
  handleListCustomer,
  params,
}: {
  handleListCustomer: Function;
  navigate?: any;
  params?: CellDoubleClickedEvent<any>;
  isChooseCongNo?: boolean;
  disible?: boolean;
}) => {
  const [data, setData] = useState<Customer[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [customerInfo, setCustomerInfo] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    keySearch: "",
    Phone: "",
    TaxCode: "",
    Code: "",
    CusCode: "",
    DebtGroup: "",
  });

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const headerRef = React.useRef<HTMLDivElement>(null);

  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<any[]>([]);
  const gridSpan = { base: 12, sm: 1.5, md: 1.5, lg: 1.5, xl: 1.5 };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "index",
        header: "STT",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        // Cell: ({ row }) => (
        //   <Text size="12.5px">{row.index === -1 ? "" : row.index + 1}</Text>
        // ),
        size: 50,
      },
      {
        accessorKey: "code",
        header: "Mã khách hàng",
        // Cell: ({ renderedCellValue, row }) => (
        //   <Badge
        //     radius="sm"
        //     variant="light"
        //     color="blue"
        //     style={{ cursor: "pointer" }}
        //   >
        //     {renderedCellValue === null ? null : renderedCellValue}
        //   </Badge>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "groupName",
        header: "Nhóm khách hàng",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px" fw={"bold"}>
        //     {renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "companyName",
        header: "Tên doanh nghiệp",
        // Cell: ({ renderedCellValue, row }: any) => (
        //   <Text size="12.5px" fw={"bold"}>
        //     {row.original.type?.toString() === "1"
        //       ? "Khách hàng cá nhân"
        //       : row.original.companyName}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute1",
        header: "Đối tượng công nợ",
        // Cell: ({ renderedCellValue, row }) =>
        //   renderedCellValue === null ? null : (
        //     <Badge
        //       radius="sm"
        //       variant="light"
        //       color="violet"
        //       style={{ cursor: "pointer" }}
        //     >
        //       {renderedCellValue === null ? null : renderedCellValue}
        //     </Badge>
        //   ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "name",
        header: "Họ và tên",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }: any) => (
          <Text >
            {row.original.type === 4 ? row.original.buyerName : row.original.name}
          </Text>
        ),
      },
      {
        accessorKey: "telephoneNumber",
        header: "Số điện thoại",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        // Cell: ({ renderedCellValue, row }: any) => (
        //   <Text size="12.5px" fw={"bold"}>
        //     {renderedCellValue}
        //   </Text>
        // ),
      },
      {
        accessorKey: "debtLimit",
        header: "Giới hạn công nợ",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "attribute2",
        header: "Thời hạn công nợ",
        // Cell: ({ renderedCellValue }: any) => (
        //   <Text size="12.5px">
        //     {renderedCellValue === null ? "" : renderedCellValue}
        //   </Text>
        // ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },

      {
        accessorKey: "email",
        header: "Email",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "provinceName",
        header: "Tỉnh/Thành phố",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "districtName",
        header: "Quận/Huyện",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "communeName",
        header: "Phường/Xã",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "address",
        header: "Địa chỉ cụ thể",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
    ],
    []
  );
  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }

    if (search.CusCode) {
      url += `&CusCode=${search.CusCode}`;
    }

    if (search.DebtGroup) {
      url += `&DebtGroup=${search.DebtGroup}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblDmCustomer/get-list${url}`
      );
      if (response && response.success) {
        let result = response?.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response?.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    // getRowId: (row) => row.id.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: { pageSize: 50, pageIndex: 0 },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "62.5vh", minHeight: "300px" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: (e) => {
      setPagination(e);
    },
    // manualFiltering: true,
    manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },

    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        handleListCustomer(
          row.original.type === 4
            ? { ...row.original, name: row.original.buyerName }
            : row.original,
          params
        );
        modals.closeAll();
      },
      sx: {
        cursor: "pointer", //you might want to change the cursor too when adding an onClick
      },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
          border: "1px solid #dee2e6",
          padding: "10px",
        }}
      >
        <Grid>
          <Grid.Col span={{ base: 12 }}>
            <Grid align="center" gutter={"xs"}>
              <Grid.Col span={gridSpan}>
                <Input
                  flex={1}
                  placeholder="Nhập từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconSearch
                      size={"20"}
                      color={cobalt_blue.base}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={gridSpan}>
                <Input
                  flex={1}
                  placeholder="Nhập mã khách hàng"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconSearch
                      size={"20"}
                      color={cobalt_blue.base}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "CusCode");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={gridSpan}>
                <Input
                  flex={1}
                  placeholder="Đối tượng công nợ"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconUsers size={"20"} color={cobalt_blue.base}></IconUsers>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "DebtGroup");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={gridSpan}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ListCustomer;
